/**
 * trimVersion returns the resource name without the version
 * @param name a resource name
 * @returns
 */
export function trimVersion(name: string): string {
  return name.split(":")[0];
}

/**
 * resourceVersion returns the resource version without the name or an empty
 * string if there was no version.
 * @param name a resource name
 * @returns
 */
export function resourceVersion(name: string): string {
  const parts = name.split(":");
  return parts.length >= 2 ? parts[1] : "";
}

/**
 * asCurrentVersion returns the resource name specified at the current version
 * @param name the resource name
 */
export function asCurrentVersion(name: string): string {
  return `${trimVersion(name)}:current`;
}

/**
 * latestVersion returns the resource name specified at the latest version
 * @param name the resource name
 */
export function asLatestVersion(name: string): string {
  return `${trimVersion(name)}:latest`;
}

/**
 * nameAndVersion returns the name and version joined with ":".
 * If the version is not specified, the name is returned.
 * @param name the resource name
 * @param version the version number
 */
export function nameAndVersion(
  name: string,
  version?: number | string,
): string {
  return version ? `${trimVersion(name)}:${version}` : name;
}
